var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"uic-segmented-progressbar",class:{
    'uic-bordered-segmented-progressbar': _vm.showBorder,
  },style:({
    'border-color': _vm.borderColor,
    'border-radius': _vm.borderRadius || '2.5px',
    'height': _vm.height || '50px',
    'width': _vm.width || '100%',
  })},_vm._l((_vm.segmentArray),function(segment,index){return _c('span',{staticClass:"uic-progressbar-segment",class:{
      'uic-blinking-progressbar-segment': segment.shouldBlink,
      'uic-inactive-progressbar-segment': index >= _vm.progressIndex && !segment.shouldBlink,
    },style:({
      'border-radius': _vm.segmentBorderRadius || '2.5px',
      'background-color': _vm.segmentColor || '#000',
      'width': _vm.segmentWidth,
      'margin-left': index > 0 ? `${_vm.segmentMargin / 2}%` : '0%',
      'margin-right': index < _vm.segmentArray.length - 1 ? `${_vm.segmentMargin / 2}%` : '0%',
    })})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }